module.exports = __webpack_public_path__ + "BannerNavidad2024.91f9419414d4c1829662b66e8d60950e.png";